import { FC, useState } from 'react';
import dayjs from 'dayjs';
import {
    Chart as ChartJS,
    ChartOptions,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ScaleOptions,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { LineChartProps } from '@entities/rKeeper';
import {
    generateChartData,
    footer,
    yScale,
} from '@pages/rkeeper/components/revenue/ui/chartConstants';
import * as S from './styles';
import { LegendRestContainer } from '@pages/rkeeper/components/revenue/ui';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const OriginsLineChart: FC<LineChartProps> = ({ chartData }) => {
    const [hiddenData, setHiddenData] = useState<number[]>([]);

    const { range, values } = chartData;

    const xScale: ScaleOptions<'category'> = {
        type: 'category',
        ticks: {
            callback: (value: string | number, index: number) => {
                if (typeof value === 'number') {
                    const rangeLength =
                        index % (Math.floor(range.length / 15) + 1);
                    return rangeLength === 0
                        ? dayjs(range[value]).format('DD.MM')
                        : '';
                }
                return value;
            },
        },
    };
    const data = generateChartData(range, values, hiddenData);

    const options: ChartOptions<'line'> = {
        maintainAspectRatio: false,
        responsive: true,
        interaction: {
            mode: 'index',
        },
        layout: {
            padding: {
                top: 10,
                bottom: 20,
            },
        },

        plugins: {
            tooltip: {
                mode: 'index' as 'index',
                intersect: true,
                usePointStyle: true,
                callbacks: {
                    footer,
                },
            },
            legend: {
                display: false,
            },
            title: {
                display: false,
                text: 'Chart.js Line Chart',
            },
        },
        elements: {
            line: {
                tension: 0.4,
                borderJoinStyle: 'round' as const,
            },
            point: {
                hoverRadius: 6,
                backgroundColor: '#ffffff',
                borderWidth: 1,
                hoverBorderWidth: 2,
            },
        },
        scales: {
            x: xScale,
            y: yScale,
        },
    };
    return (
        <S.ChartContentWrapper>
            <S.LegendContainer>
                <LegendRestContainer
                    datas={data}
                    setHiddenDatasets={setHiddenData}
                    hiddenDatasets={hiddenData}
                />
            </S.LegendContainer>
            <S.ChartContainer>
                <Line options={options} data={data} />
            </S.ChartContainer>
        </S.ChartContentWrapper>
    );
};
